/* global document, window, location, CustomEvent, Event, setTimeout */
/* eslint-disable */
// GEO IP script to detect user location
"use strict";var geoip2=function(){function e(e,t,r,n){this.successCallback=e,this.errorCallback=t,this.type=n}var t={};e.prototype.returnSuccess=function(e){this.successCallback&&"function"==typeof this.successCallback&&this.successCallback(this.fillInObject(JSON.parse(e)))},e.prototype.returnError=function(e){this.errorCallback&&"function"==typeof this.errorCallback&&(e||(e={error:"Unknown error"}),this.errorCallback(e))};var r={country:[["continent","Object","names","Object"],["country","Object","names","Object"],["registered_country","Object","names","Object"],["represented_country","Object","names","Object"],["traits","Object"]],city:[["city","Object","names","Object"],["continent","Object","names","Object"],["country","Object","names","Object"],["location","Object"],["postal","Object"],["registered_country","Object","names","Object"],["represented_country","Object","names","Object"],["subdivisions","Array",0,"Object","names","Object"],["traits","Object"]]};return e.prototype.fillInObject=function(e){for(var t="country"===this.type?r.country:r.city,n=0;n<t.length;n++)for(var o=t[n],s=e,i=0;i<o.length;i+=2){var c=o[i];s[c]||(s[c]="Object"===o[i+1]?{}:[]),s=s[c]}try{Object.defineProperty(e.continent,"continent_code",{enumerable:!1,get:function(){return this.code},set:function(e){this.code=e}})}catch(u){e.continent.code&&(e.continent.continent_code=e.continent.code)}if("country"!==this.type)try{Object.defineProperty(e,"most_specific_subdivision",{enumerable:!1,get:function(){return this.subdivisions[this.subdivisions.length-1]},set:function(e){this.subdivisions[this.subdivisions.length-1]=e}})}catch(u){e.most_specific_subdivision=e.subdivisions[e.subdivisions.length-1]}return e},e.prototype.getGeoIPResult=function(){var e,t=this,r=new window.XMLHttpRequest,n="https://geoip-js.com/geoip/v2.1/"+this.type+"/me?",o={referrer:location.protocol+"//"+location.hostname};if(!this.alreadyRan){this.alreadyRan=1;for(e in o)o.hasOwnProperty(e)&&o[e]&&(n+=e+"="+encodeURIComponent(o[e])+"&");n=n.substring(0,n.length-1),r.open("GET",n,!0),r.onload=function(){if("undefined"==typeof r.status||200===r.status)t.returnSuccess(r.responseText);else{var e,n=r.hasOwnProperty("contentType")?r.contentType:r.getResponseHeader("Content-Type");if(/json/.test(n)&&r.responseText.length)try{e=JSON.parse(r.responseText)}catch(o){e={code:"HTTP_ERROR",error:"The server returned a "+r.status+" status with an invalid JSON body."}}else e=r.responseText.length?{code:"HTTP_ERROR",error:"The server returned a "+r.status+" status with the following body: "+r.responseText}:{code:"HTTP_ERROR",error:"The server returned a "+r.status+" status but either the server did not return a body or this browser is a version of Internet Explorer that hides error bodies."};t.returnError(e)}},r.ontimeout=function(){t.returnError({code:"HTTP_TIMEOUT",error:"The request to the GeoIP2 web service timed out."})},r.onerror=function(){t.returnError({code:"HTTP_ERROR",error:"There was a network error receiving the response from the GeoIP2 web service."})},r.send(null)}},t.country=function(t,r,n){var o=new e(t,r,n,"country");o.getGeoIPResult()},t.city=function(t,r,n){var o=new e(t,r,n,"city");o.getGeoIPResult()},t.insights=function(t,r,n){var o=new e(t,r,n,"insights");o.getGeoIPResult()},t}();
/* eslint-enable */
/* global ConfigurationResolver */
/* eslint-disable consistent-return */
/* eslint-disable complexity */
/* eslint-disable no-unused-vars */
var mountCookieConsent = (function () {
    'use strict';

    var hoursInADay = 24;
    var minutesInAnHour = 60;
    var secondsInAMinute = 60;
    var millisecondsInASecond = 1000;
    var millisecondsInADay = hoursInADay * minutesInAnHour * secondsInAMinute * millisecondsInASecond;
    var firstCaptureGroupMatchIndex = 1;
    var secondArrayIndex = 1;
    var firstStringCharacterIndex = 0;
    var secondStringCharacterIndex = 1;

    var countryCode = null;
    var countryCodeCookieName = 'cookieconsent_country_code';
    var countryCodeCookieTTLDays = 1;
    var consentCookieTTLDays = 30;
    var defaultContent = {
        header: '',
        message: 'Jamf uses cookies to enhance your browsing experience, personalize ads and analyze usage. Without cookies, you may not be able to use certain features of our sites. To learn more, visit our <a href="https://www.jamf.com/privacy-policy/">Privacy Policy</a>.',
        dismiss: 'Allow',
        allow: 'Allow',
        deny: 'Decline',
        link: '',
        href: '',
        close: ''
    };

    // "Edit preferences" bar values
    var prefsBar = {
        id: 'cc-prefs-bar',
        revokeButtonText: 'Cookie Policy',
        description: 'To change your preferences, <a class="cc-revoke">click here</a>.',
        privacyText: 'Privacy Policy',
        privacyLink: 'https://www.jamf.com/privacy-policy/',
        cookieName: 'cookieconsent_dismissed'
    };

    var $element = document.querySelector('html');
    var eventAllow = 'jamf.cookieConsentAllow';
    var eventDeny = 'jamf.cookieConsentDeny';
    var eventLoad = 'jamf.cookieConsentLoad';
    var eventRevoke = 'jamf.cookieConsentRevoke';
    var eventHidePrefs = 'jamf.cookieConsentHidePrefs';
    var eventShowPrefs = 'jamf.cookieConsentShowPrefs';

    var eventDetailChange = {
        'detail': {
            action: 'change'
        }
    };
    var eventDetailInit = {
        'detail': {
            action: 'init'
        }
    };

    var initializedCookieName = 'cookieconsent_initialized';
    var optType = 'opt-out';
    var options = $element.dataset;
    var cookieConsentVersion = null;
    var isOneTrustAllowed = true;

    if (window.ConfigurationResolver) {
        cookieConsentVersion = ConfigurationResolver.get('cookieVersion');
        isOneTrustAllowed = ConfigurationResolver.get('feature:otcc');
    }

    var jamfSegmentScriptSelector;

    if (document.querySelector('[src*="skilljar"]')) {
        jamfSegmentScriptSelector = document.querySelector('[src*="skilljar"]');
    }

    if (document.querySelector('[src*="salesforce-accounts"]')) {
        jamfSegmentScriptSelector = document.querySelector('[src*="salesforce-accounts"]');
    }

    if (document.querySelector('[src*="jamf-segment"]')) {
        jamfSegmentScriptSelector = document.querySelector('[src*="jamf-segment"]');
    }

    var jamfSegmentScriptDataset;

    if (jamfSegmentScriptSelector && jamfSegmentScriptSelector.dataset) {
        jamfSegmentScriptDataset = jamfSegmentScriptSelector.dataset;

        if (jamfSegmentScriptDataset.cookieconsentVersion) {
            cookieConsentVersion = jamfSegmentScriptDataset.cookieconsentVersion;
        }
    }

    if (cookieConsentVersion === null || cookieConsentVersion === '1') {
        isOneTrustAllowed = false;
    }

    /**
     * @param {object} defaults
     */
    var setPrefsBarValues = function (defaults) {
        if ('ccDismiss' in defaults) {
            prefsBar.description = defaults.ccDismiss;
        }
        if ('ccPrivacyPolicy' in defaults) {
            prefsBar.privacyText = defaults.ccPrivacyPolicy;
        }
        if ('ccPrivacyUrl' in defaults) {
            prefsBar.privacyLink = defaults.ccPrivacyUrl;
        }
    };

    // Allow override of text based options for multi-lingual or domain specific purposes.
    // Overrides must be prefixed with cc- as to not collide with other attributes that may be on the html tag.
    if (typeof options === 'object') {
        for (var key in defaultContent) {
            if (Object.prototype.hasOwnProperty.call(defaultContent, key)) {
                var keyName = key.charAt(firstStringCharacterIndex).toUpperCase() + key.slice(secondStringCharacterIndex);

                if (options['cc' + keyName]) {
                    defaultContent[key] = options['cc' + keyName];
                }
            }
        }

        // Make special exceptions so the language override is managed similarly to other strings
        setPrefsBarValues(options);
    }

    // Set values for cookie preferences sections
    var revokePill = '<div id="cc-pill" class="cc-btn cc-revoke">' + prefsBar.revokeButtonText + '</div>';
    var editPrefsDescription = '<span class="cc-message" role="dialog" aria="polite" aria-label="Cookie preferences">' + prefsBar.description + '</span>';
    var closeIcon = '<?xml version="1.0" encoding="utf-8"?><svg version="1.0" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 34 34" enable-background="new 0 0 34 34" xml:space="preserve"><path d="M32.6,30.4L19.1,17L32.6,3.6c0.6-0.6,0.6-1.5,0-2.1c-0.6-0.6-1.5-0.6-2.1,0L17,14.9L3.6,1.4C3,0.9,2,0.9,1.4,1.4 C0.9,2,0.9,3,1.4,3.6L14.9,17L1.4,30.4c-0.6,0.6-0.6,1.5,0,2.1C1.7,32.9,2.1,33,2.5,33s0.8-0.1,1.1-0.4L17,19.1l13.4,13.4 c0.3,0.3,0.7,0.4,1.1,0.4s0.8-0.1,1.1-0.4C33.1,32,33.1,31,32.6,30.4z"/></svg>';
    var closeButton = '<div class="close">' + closeIcon + '</div>';
    var privacyLink = '<a href="' + prefsBar.privacyLink + '" class="cc-btn">' + prefsBar.privacyText + '</a>';

    // Put together the cookie preferences banner
    var defaultRevoke = '<div id="cc-edit-container">' + revokePill + '<div id="' + prefsBar.id + '" class="cc-window cc-banner">' + editPrefsDescription + '<div class="cc-compliance">' + privacyLink + closeButton + '</div></div></div>';

    /**
     * @param {string} hostName (e.g. 'www.jamf.com')
     * @returns {string} domain to use in a cookie (e.g. '.jamf.com')
     */
    var determineCookieDomainFromHostName = function (hostName) {
        var minimumNumberOfLabelsForWildcard = 3;

        if (hostName === 'jamf.com') {
            return '.jamf.com';
        }

        var hostNameLabels = hostName.split('.');

        if (hostNameLabels.length < minimumNumberOfLabelsForWildcard) {
            return '.' + hostName;
        }

        return '.' + hostNameLabels.slice(secondArrayIndex).join('.');
    };

    var cookieDomain = determineCookieDomainFromHostName(location.hostname);

    /**
     * @param {string} initialCountryCode
     */
    var initCookieConsent = function (initialCountryCode) {
        // CookieConsent's options allow passing a law: {countryCode: 'US'} object when initialising, but if the country
        // is found to not be subject to the law, CookieConsent doesn't even call the onInitialise() method, thus our
        // event dispatching in the onInitialise() method is never called, which means we can't take additional action
        // to load scripts if lets say the user is in the US. So we're checking the country manually and if it
        // immediately finds that the country is not subject to the law, then we dispatch the allow event and ignore
        // everything else.

        var law = new window.cookieconsent.Law({
            countryCode: initialCountryCode
        });

        var result = law.applyLaw({}, initialCountryCode);

        // if the country is outside of GDPR countries, we want to allow the old cookie consent here (also we need to check if OneTrust is not on, as then, OneTrust would handle it)
        if (result.enabled === false && ((cookieConsentVersion === null && isOneTrustAllowed === false) || cookieConsentVersion === '1' || (cookieConsentVersion === '2' && isOneTrustAllowed === false))) {
            $element.dispatchEvent(new CustomEvent(eventAllow, eventDetailInit));

            return;
        }

        var cookieOptions = {
            expiryDays: consentCookieTTLDays
        };

        if (cookieDomain) {
            cookieOptions.domain = cookieDomain;
        }

        // if it's GDPR country AND we are not using OneTrust, we want to keep using the old cookie consent
        if ((cookieConsentVersion === null && isOneTrustAllowed === false) || cookieConsentVersion === '1' || (cookieConsentVersion === '2' && isOneTrustAllowed === false)) {
            window.cookieconsent.initialise({
                animateRevokable: false,
                content: defaultContent,
                cookie: cookieOptions,
                position: 'bottom',
                type: optType,
                revokeBtn: defaultRevoke,

                // Before user has accepted or declined cookies
                onPopupOpen: function () {
                    // If the user has already seen the pop-up the first time, don't trigger this event again,
                    // it will call a second analytics page view and skew impressions. This will not prevent the
                    // pop-up from displaying, it will just prevent additional dispatched events.
                    if (!getCookie(initializedCookieName)) {
                        $element.dispatchEvent(new CustomEvent(eventLoad, eventDetailInit));
                        setCookie(initializedCookieName, true);
                    }
                },

                // After user has accepted or declined cookies
                onInitialise: function () {
                    var type = this.options.type;
                    var didConsent = this.hasConsented();

                    if (type === optType && !didConsent) {
                        $element.dispatchEvent(new CustomEvent(eventDeny, eventDetailInit));
                    } else {
                        $element.dispatchEvent(new CustomEvent(eventAllow, eventDetailInit));
                    }
                },

                onStatusChange: function () {
                    var type = this.options.type;
                    var didConsent = this.hasConsented();

                    if (type === optType && !didConsent) {
                        showPrefsBar();
                        $element.dispatchEvent(new CustomEvent(eventDeny, eventDetailChange));
                    } else {
                        hidePrefsBar();
                        $element.dispatchEvent(new CustomEvent(eventAllow, eventDetailChange));
                    }
                },

                onRevokeChoice: function () {
                    setCookie(prefsBar.cookieName, 'false', consentCookieTTLDays);
                    $element.dispatchEvent(new Event(eventRevoke));
                }
            });

            // Edit cookie preferences Dismiss button
            // eslint-disable-next-line no-magic-numbers
            document.getElementById(prefsBar.id).getElementsByClassName('close')[0].addEventListener('click', function (e) {
                // hide this bar, set our cookie to 'dismissed'
                setCookie(prefsBar.cookieName, 'true', consentCookieTTLDays);
                hidePrefsBar();
            });

            // Display the yellow bar by default?
            if (getCookie(prefsBar.cookieName) === 'true') {
                hidePrefsBar();
            } else {
                showPrefsBar();
            }
        }
    };

    /**
     * Show the cookie preference bar
     */
    var showPrefsBar = function () {
        var bar = document.getElementById(prefsBar.id);

        bar.style.opacity = 1;
        bar.style.display = 'flex';
        bar.classList.remove('cc-invisible');

        $element.dispatchEvent(new CustomEvent(eventShowPrefs));
    };

    /**
     * Hide (animate) the cookie preference bar
     */
    var hidePrefsBar = function () {
        var bar = document.getElementById(prefsBar.id);

        bar.style.opacity = 0;
        bar.classList.add('cc-invisible');

        setTimeout(function () {
            bar.style.display = 'none';
        }, millisecondsInASecond);

        $element.dispatchEvent(new CustomEvent(eventHidePrefs));
    };

    /**
     * @param {string} text cookie name
     * @returns {string} escaped cookie name with certain characters stripped out?
     */
    var escape = function (text) {
        return text.replace(/([.*+?^${}()|[\]/\\])/g, '\\$1');
    };

    /**
     * @param {string} name cookie name
     * @returns {string|null} cookie value, if available
     */
    var getCookie = function (name) {

        var match = document.cookie.match(RegExp('(?:^|;\\s*)' + escape(name) + '=([^;]*)'));

        if (match) {
            return match[firstCaptureGroupMatchIndex];
        }

        return null;
    };

    /**
     * @param {string} name
     * @param {string} value
     * @param {int} days
     */
    var setCookie = function (name, value, days) {
        var domain = '';
        var expires = '';

        if (days) {
            var date = new Date();

            date.setTime(date.getTime() + (days * millisecondsInADay));
            expires = '; expires=' + date.toUTCString();
        }

        if (cookieDomain) {
            domain = '; domain=' + cookieDomain;
        }

        document.cookie = name + '=' + (value || '') + expires + domain + '; path=/; SameSite=Lax';
    };

    /**
     * @todo getters shouldn't have side-effects... we should do the setCookie() elsewhere
     *
     * @param {object} response country code API lookup response
     * @returns {string|null} country code, or null if it's not found
     */
    var getCountryCode = function (response) {
        if (response && response.country) {
            setCookie(countryCodeCookieName, response.country, countryCodeCookieTTLDays);

            return response.country;
        }

        return null;
    };

    /**
     * Mount and initialize Cookie Consent
     */
    var mountCookieConsentClosure = function () {
        if (countryCode) {
            initCookieConsent(countryCode);
        } else {
            // This 'geofeed' function is called automatically by the OneTrust script that gets included in the <head> tag as below
            // source: https://community.cookiepro.com/s/article/UUID-f1caf6bb-0003-8e79-6caf-2a7d04e357d7?language=en_US
            window.geofeed = function (userLocationData) {
                if (userLocationData) {
                    initCookieConsent(getCountryCode(userLocationData));

                    return;
                }

                // in case of empty/falsy userLocationData do the maxmind fallback
                fallbackToMaxmindToGetUserLocationData();
            };

            var fallbackToMaxmindToGetUserLocationData = function () {
                geoip2.country(function (location) {
                    var geoip2CountryCode = location.country.iso_code;

                    setCookie(countryCodeCookieName, geoip2CountryCode, countryCodeCookieTTLDays);
                    initCookieConsent(geoip2CountryCode);
                });
            };

            // Call geo-location JSON service
            var oneTrustLocationScript = document.createElement('script');

            oneTrustLocationScript.setAttribute('src', 'https://geolocation.onetrust.com/cookieconsentpub/v1/geo/location/geofeed');
            // If OneTrust script fails to load, fall back to Maxmind
            oneTrustLocationScript.onerror = fallbackToMaxmindToGetUserLocationData;
            document.head.appendChild(oneTrustLocationScript);
        }
    };

    // First, does the element have code already?
    if ($element.dataset.countryCode) {
        countryCode = $element.dataset.countryCode;
    } else {
        countryCode = getCookie(countryCodeCookieName);
    }

    // Prevent Cookie Consent initialization if html has cc-disable-autoinit attribute is set to 1
    if (options.ccDisableAutoinit) {
        return mountCookieConsentClosure;
    }

    mountCookieConsentClosure();
})();
